import { ColumnDef } from '@tanstack/react-table'
import { GetReferredPlayersData } from '@/modules/manage-player/type'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'

export const referredColumns: ColumnDef<GetReferredPlayersData>[] = [
	{
		accessorKey: 'username',
		header: 'ชื่อผู้ใช้',
		cell: ({ row }) => (
			<UsernameCell
				username={
					(row.original as Record<string, unknown>).username as string | null
				}
			/>
		),
	},
	{
		accessorKey: 'phone',
		header: 'สมาชิก',
		cell: ({ row }) => (
			<PhoneCell
				playerId={row.original.playerId}
				phone={row.getValue('phone') as string}
			/>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สมัคร',
		cell: ({ row }) =>
			format(new Date(row.original.createdAt || ''), 'PPP HH:mm น.', {
				locale: th,
			}),
	},
	{
		id: 'detail',
		header: 'รายละเอียด',
		cell: ({ row }) => {
			const playerId = row.original.playerId
			return (
				<Link to={`/operator/get-player-list/player-detail/${playerId}`}>
					<Button variant="default">ดูรายละเอียด</Button>
				</Link>
			)
		},
	},
]
